<div class="wrapper" style="background-color: white">
  <div class="platform-header">
    <div class="ph-right">
      <h2>
        Simple, <span class="highlight">Secure</span> &<br />
        <span class="highlight">Scalable</span> for all Platforms.
      </h2>
    </div>
    <div class="ph-left">
      <a class="learn-more">Learn About our Platform →</a>
    </div>
  </div>
  <div class="scroll-wrapper">
    <div class="platform-container">
      <div class="box" *ngFor="let item of boxes; let i = index">
        <div
          class="image-container"
          [ngClass]="{
            'image-right': i !== 0,
            'image-border': i === 1,
            'new-class': i === 0
          }"
        >
          <img [src]="item.image" alt="Box Image" />
        </div>
        <div class="platform-description">
          <h2>{{ item.title }}</h2>
          <p>{{ item.description }}</p>
          <a target="_blank">{{ item.linkText }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
